import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  signInZoho: {
    method: 'GET',
    url: `${configs.api.signInZoho}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const signInZoho = async (params = {}) => {
  const res = await resource.signInZoho({
    return_to: params.serviceurl,
  })

  return res.body
}

export default {
  initResource,
  signInZoho,
}
